import type { Gender } from '@/store/people/types';
import {
  Input,
  Select,
  SelectItem,
  type SharedSelection,
} from '@/components/ui';
import { StandardIcon } from '../icon';

export function GenderSelect({
  value,
  onChange,
  label,
  className,
  isDisabled,
  isReadOnly,
}: {
  value?: Gender;
  onChange: (value: Gender | undefined) => void;
  label?: string;
  className?: string;
  isDisabled?: boolean;
  isReadOnly?: boolean;
}) {
  const selectedKeys = value ? [value] : [];
  const onSelectionChange = (keys: SharedSelection) => {
    if (!onChange) {
      return;
    }

    const values = Array.from(keys);
    if (!values.length) {
      onChange(undefined);
    } else {
      onChange(keys.currentKey as Gender);
    }
  };

  if (isReadOnly) {
    let display = '';
    if (value) {
      const item = Items.find((item) => item.key === value);
      if (item) {
        display = item.label;
      }
    }

    return (
      <Input
        label={label}
        defaultValue={display}
        isReadOnly
        placeholder='Unspecified'
      />
    );
  }

  return (
    <Select
      label={label}
      className={className}
      items={Items}
      selectedKeys={selectedKeys}
      onSelectionChange={onSelectionChange}
      isDisabled={isDisabled}
    >
      {(item) => <SelectItem key={item.key}>{item.label}</SelectItem>}
    </Select>
  );
}

export function GenderDisplay({
  value,
  variant = 'standard',
  className,
}: {
  value?: Gender;
  variant?: 'standard' | 'short' | 'icon';
  className?: string;
}) {
  if (!value) {
    return null;
  }

  if (variant === 'short') {
    return <span className={className}>{value.toUpperCase()}</span>;
  }

  if (variant === 'icon') {
    return (
      <StandardIcon
        className={className}
        id={value === 'f' ? 'mdi:human-female' : 'mdi:human-male'}
      />
    );
  }

  return (
    <span className={className}>
      {Items.find((item) => item.key === value)?.label}
    </span>
  );
}

const Items: { key: Gender; label: string }[] = [
  { key: 'm', label: 'Male' },
  { key: 'f', label: 'Female' },
];
